// Logo imports
import YankeesLogo from '../images/mlb/new-york-yankees-logo.svg';
import RedSoxLogo from '../images/mlb/boston-red-sox-logo.svg';
import BlueJaysLogo from '../images/mlb/toronto-blue-jays-logo.svg';
import RaysLogo from '../images/mlb/tampa-bay-rays-logo.svg';
import OriolesLogo from '../images/mlb/baltimore-orioles-logo.svg';
import WhiteSoxLogo from '../images/mlb/chicago-white-sox-logo.svg';
import GuardiansLogo from '../images/mlb/cleveland-indians-logo.svg';
import TigersLogo from '../images/mlb/detroit-tigers-logo.svg';
import RoyalsLogo from '../images/mlb/kansas-city-royals-logo.svg';
import TwinsLogo from '../images/mlb/minnesota-twins-logo.svg';
import AstrosLogo from '../images/mlb/houston-astros-logo.svg';
import MarinersLogo from '../images/mlb/seattle-mariners-logo.svg';
import RangersLogo from '../images/mlb/texas-rangers-logo.svg';
import AngelsLogo from '../images/mlb/los-angeles-angels-logo.svg';
import AthleticsLogo from '../images/mlb/oakland-athletics-logo.svg';
import BravesLogo from '../images/mlb/atlanta-braves-logo.svg';
import MetsLogo from '../images/mlb/new-york-mets-logo.svg';
import PhilliesLogo from '../images/mlb/philadelphia-phillies-logo.svg';
import MarlinsLogo from '../images/mlb/miami-marlins-logo.svg';
import NationalsLogo from '../images/mlb/washington-nationals-logo.svg';
import CubsLogo from '../images/mlb/chicago-cubs-logo.svg';
import BrewersLogo from '../images/mlb/milwaukee-brewers-logo.svg';
import CardinalsLogo from '../images/mlb/st.-louis-cardinals-logo.svg';
import RedsLogo from '../images/mlb/cincinnati-reds-logo.svg';
import PiratesLogo from '../images/mlb/pittsburgh-pirates-logo.svg';
import DodgersLogo from '../images/mlb/los-angeles-dodgers-logo.svg';
import PadresLogo from '../images/mlb/san-diego-padres-logo.svg';
import GiantsLogo from '../images/mlb/san-francisco-giants-logo.svg';
import RockiesLogo from '../images/mlb/colorado-rockies-logo.svg';
import DiamondbacksLogo from '../images/mlb/arizona-diamondbacks-logo.svg';

// Team data
const mlbTeams = {
    Yankees: {
        League: 'MLB',
        Team: 'New York Yankees',
        Lat: 41.8296,
        Long: -74.9262,
        Stadium: 'Yankee Stadium',
        LeagueAbbr: 'AL',
        Division: 'East',
        acronym: 'NYY',
        logo: YankeesLogo,
        primaryColor: '#C4CED3',
        secondaryColor: '#003087',
        territory: ['West New York', 'Connecticut'],
    },
    RedSox: {
        League: 'MLB',
        Team: 'Boston Red Sox',
        Lat: 42.3467,
        Long: -71.0972,
        Stadium: 'Fenway Park',
        LeagueAbbr: 'AL',
        Division: 'East',
        acronym: 'BOS',
        logo: RedSoxLogo,
        primaryColor: '#BD3039',
        secondaryColor: '#0C2340',
        territory: ['Massachusetts', 'Rhode Island', 'Maine', "Vermont", "New Hampshire"],
    },
    BlueJays: {
        League: 'MLB',
        Team: 'Toronto Blue Jays',
        Lat: 43.6414,
        Long: -79.3894,
        Stadium: 'Rogers Centre',
        LeagueAbbr: 'AL',
        Division: 'East',
        acronym: 'TOR',
        logo: BlueJaysLogo,
        primaryColor: '#134A8E',
        secondaryColor: '#1D2D5C',
        territory: ['East New York'],
    },
    Rays: {
        League: 'MLB',
        Team: 'Tampa Bay Rays',
        Lat: 27.7683,
        Long: -82.6534,
        Stadium: 'Tropicana Field',
        LeagueAbbr: 'AL',
        Division: 'East',
        acronym: 'TB',
        logo: RaysLogo,
        primaryColor: '#092C5C',
        secondaryColor: '#8FBCE6',
        territory: ['Mid Florida', "North Florida"],
    },
    Orioles: {
        League: 'MLB',
        Team: 'Baltimore Orioles',
        Lat: 39.584,
        Long: -76.9216,
        Stadium: 'Oriole Park at Camden Yards',
        LeagueAbbr: 'AL',
        Division: 'East',
        acronym: 'BAL',
        logo: OriolesLogo,
        primaryColor: '#DF4601',
        secondaryColor: '#000000',
        territory: ['Maryland'],
    },
    WhiteSox: {
        League: 'MLB',
        Team: 'Chicago White Sox',
        Lat: 41.8299,
        Long: -87.6338,
        Stadium: 'Guaranteed Rate Field',
        LeagueAbbr: 'AL',
        Division: 'Central',
        acronym: 'CWS',
        logo: WhiteSoxLogo,
        primaryColor: '#27251F',
        secondaryColor: '#C4CED4',
        territory: ['Chicago'],
    },
    Guardians: {
        League: 'MLB',
        Team: 'Cleveland Guardians',
        Lat: 41.4962,
        Long: -81.6852,
        Stadium: 'Progressive Field',
        LeagueAbbr: 'AL',
        Division: 'Central',
        acronym: 'CLE',
        logo: GuardiansLogo,
        primaryColor: '#0F223E',
        secondaryColor: '#E50022',
        territory: ['Northeast Ohio'],
    },
    Tigers: {
        League: 'MLB',
        Team: 'Detroit Tigers',
        Lat: 42.339,
        Long: -83.0485,
        Stadium: 'Comerica Park',
        LeagueAbbr: 'AL',
        Division: 'Central',
        acronym: 'DET',
        logo: TigersLogo,
        primaryColor: '#0C2340',
        secondaryColor: '#FA4616',
        territory: ['Michigan'],
    },
    Royals: {
        League: 'MLB',
        Team: 'Kansas City Royals',
        Lat: 39.0516,
        Long: -94.4805,
        Stadium: 'Kauffman Stadium',
        LeagueAbbr: 'AL',
        Division: 'Central',
        acronym: 'KC',
        logo: RoyalsLogo,
        primaryColor: '#004687',
        secondaryColor: '#BD9B60',
        territory: ['Kansas', "Nebraska", "Iowa"],
    },
    Twins: {
        League: 'MLB',
        Team: 'Minnesota Twins',
        Lat: 44.9817,
        Long: -93.2779,
        Stadium: 'Target Field',
        LeagueAbbr: 'AL',
        Division: 'Central',
        acronym: 'MIN',
        logo: TwinsLogo,
        primaryColor: '#002B5C',
        secondaryColor: '#D31145',
        territory: ['Minnesota', "North Dakota", "South Dakota"],
    },

    Diamondbacks: {
        League: 'MLB',
        Team: 'Arizona Diamondbacks',
        Lat: 33.4455,
        Long: -112.0667,
        Stadium: 'Chase Field',
        LeagueAbbr: 'NL',
        Division: 'West',
        acronym: 'ARI',
        logo: DiamondbacksLogo,
        primaryColor: '#A71930',
        secondaryColor: '#000000',
        territory: ['Arizona', 'New Mexico'],
    },
    Braves: {
        League: 'MLB',
        Team: 'Atlanta Braves',
        Lat: 33.8908,
        Long: -84.4678,
        Stadium: 'Truist Park',
        LeagueAbbr: 'NL',
        Division: 'East',
        acronym: 'ATL',
        logo: BravesLogo,
        primaryColor: '#13274F',
        secondaryColor: '#CE1141',
        territory: ['Georgia', "Mississippi", "Alabama", "South Carolina", "Tennessee", "North Carolina"],
    },
    Mets: {
        League: 'MLB',
        Team: 'New York Mets',
        Lat: 40.3571,
        Long: -73.4458,
        Stadium: 'Citi Field',
        LeagueAbbr: 'NL',
        Division: 'East',
        acronym: 'NYM',
        logo: MetsLogo,
        primaryColor: '#002D72',
        secondaryColor: '#FF5910',
        territory: ['New Jersey', "Delaware"],
    },
    Phillies: {
        League: 'MLB',
        Team: 'Philadelphia Phillies',
        Lat: 39.9053,
        Long: -75.1665,
        Stadium: 'Citizens Bank Park',
        LeagueAbbr: 'NL',
        Division: 'East',
        acronym: 'PHI',
        logo: PhilliesLogo,
        primaryColor: '#E81828',
        secondaryColor: '#002D72',
        territory: ['East Pennsylvania'],
    },
    Marlins: {
        League: 'MLB',
        Team: 'Miami Marlins',
        Lat: 25.7781,
        Long: -80.2197,
        Stadium: 'LoanDepot Park',
        LeagueAbbr: 'NL',
        Division: 'East',
        acronym: 'MIA',
        logo: MarlinsLogo,
        primaryColor: '#00A3E0',
        secondaryColor: '#EF3340',
        territory: ['South Florida'],
    },
    Nationals: {
        League: 'MLB',
        Team: 'Washington Nationals',
        Lat: 38.073,
        Long: -78.4074,
        Stadium: 'Nationals Park',
        LeagueAbbr: 'NL',
        Division: 'East',
        acronym: 'WSH',
        logo: NationalsLogo,
        primaryColor: '#AB0003',
        secondaryColor: '#14225A',
        territory: ['Virginia'],
    },
    Cubs: {
        League: 'MLB',
        Team: 'Chicago Cubs',
        Lat: 41.9484,
        Long: -87.6553,
        Stadium: 'Wrigley Field',
        LeagueAbbr: 'NL',
        Division: 'Central',
        acronym: 'CHC',
        logo: CubsLogo,
        primaryColor: '#0E3386',
        secondaryColor: '#CC3433',
        territory: ['Illinois', "Indiana"],
    },
    Brewers: {
        League: 'MLB',
        Team: 'Milwaukee Brewers',
        Lat: 43.028,
        Long: -87.9711,
        Stadium: 'American Family Field',
        LeagueAbbr: 'NL',
        Division: 'Central',
        acronym: 'MIL',
        logo: BrewersLogo,
        primaryColor: '#FFC52F',
        secondaryColor: '#12284B',
        territory: ['Wisconsin'],
    },
    Cardinals: {
        League: 'MLB',
        Team: 'St. Louis Cardinals',
        Lat: 38.6226,
        Long: -90.1928,
        Stadium: 'Busch Stadium',
        LeagueAbbr: 'NL',
        Division: 'Central',
        acronym: 'STL',
        logo: CardinalsLogo,
        primaryColor: '#C41E3A',
        secondaryColor: '#0C2340',
        territory: ['Missouri'],
    },
    Reds: {
        League: 'MLB',
        Team: 'Cincinnati Reds',
        Lat: 39.0979,
        Long: -84.5071,
        Stadium: 'Great American Ball Park',
        LeagueAbbr: 'NL',
        Division: 'Central',
        acronym: 'CIN',
        logo: RedsLogo,
        primaryColor: '#C6011F',
        secondaryColor: '#000000',
        territory: ['Kentucky', "Ohio"],
    },
    Pirates: {
        League: 'MLB',
        Team: 'Pittsburgh Pirates',
        Lat: 40.4469,
        Long: -80.0057,
        Stadium: 'PNC Park',
        LeagueAbbr: 'NL',
        Division: 'Central',
        acronym: 'PIT',
        logo: PiratesLogo,
        primaryColor: '#FDB827',
        secondaryColor: '#27251F',
        territory: ['Pennsylvania', "West Virginia"],
    },
    Dodgers: {
        League: 'MLB',
        Team: 'Los Angeles Dodgers',
        Lat: 34.0739,
        Long: -118.2400,
        Stadium: 'Dodger Stadium',
        LeagueAbbr: 'NL',
        Division: 'West',
        acronym: 'LAD',
        logo: DodgersLogo,
        primaryColor: '#005A9C',
        secondaryColor: '#EF3E42',
        territory: ['Mid California', 'Nevada', 'Utah'],
    },
    Padres: {
        League: 'MLB',
        Team: 'San Diego Padres',
        Lat: 32.7076,
        Long: -117.1566,
        Stadium: 'Petco Park',
        LeagueAbbr: 'NL',
        Division: 'West',
        acronym: 'SD',
        logo: PadresLogo,
        primaryColor: '#FFC425',
        secondaryColor: '#2F241D',
        territory: ['South California'],
    },
    Giants: {
        League: 'MLB',
        Team: 'San Francisco Giants',
        Lat: 37.7786,
        Long: -122.3893,
        Stadium: 'Oracle Park',
        LeagueAbbr: 'NL',
        Division: 'West',
        acronym: 'SF',
        logo: GiantsLogo,
        primaryColor: '#FD5A1E',
        secondaryColor: '#27251F',
        territory: ['North California'],
    },
    Rockies: {
        League: 'MLB',
        Team: 'Colorado Rockies',
        Lat: 39.7559,
        Long: -104.9942,
        Stadium: 'Coors Field',
        LeagueAbbr: 'NL',
        Division: 'West',
        acronym: 'COL',
        logo: RockiesLogo,
        primaryColor: '#33006F',
        secondaryColor: '#C4CED4',
        territory: ['Colorado', 'Wyoming', 'Montana'],
    },
    Angels: {
        League: 'MLB',
        Team: 'Los Angeles Angels',
        Lat: 33.8003,
        Long: -117.8827,
        Stadium: 'Angel Stadium',
        LeagueAbbr: 'AL',
        Division: 'West',
        acronym: 'LAA',
        logo: AngelsLogo,
        primaryColor: '#BA0021',
        secondaryColor: '#003263',
        territory: ['California'],
    },
    Athletics: {
        League: 'MLB',
        Team: 'Oakland Athletics',
        Lat: 37.7516,
        Long: -122.2005,
        Stadium: 'Oakland Coliseum',
        LeagueAbbr: 'AL',
        Division: 'West',
        acronym: 'OAK',
        logo: AthleticsLogo,
        primaryColor: '#003831',
        secondaryColor: '#EFB21E',
        territory: ['California'],
    },
    Astros: {
        League: 'MLB',
        Team: 'Houston Astros',
        Lat: 29.7573,
        Long: -95.3555,
        Stadium: 'Minute Maid Park',
        LeagueAbbr: 'AL',
        Division: 'West',
        acronym: 'HOU',
        logo: AstrosLogo,
        primaryColor: '#EB6E1F',
        secondaryColor: '#002D62',
        territory: ['South Texas', "Louisiana"],
    },
    Mariners: {
        League: 'MLB',
        Team: 'Seattle Mariners',
        Lat: 47.5914,
        Long: -122.3325,
        Stadium: 'T-Mobile Park',
        LeagueAbbr: 'AL',
        Division: 'West',
        acronym: 'SEA',
        logo: MarinersLogo,
        primaryColor: '#0C2C56',
        secondaryColor: '#005C5C',
        territory: ['Washington', "Oregon", "Idaho"],
    },
    Rangers: {
        League: 'MLB',
        Team: 'Texas Rangers',
        Lat: 32.7513,
        Long: -97.0822,
        Stadium: 'Globe Life Field',
        LeagueAbbr: 'AL',
        Division: 'West',
        acronym: 'TEX',
        logo: RangersLogo,
        primaryColor: '#003278',
        secondaryColor: '#C0111F',
        territory: ['Texas', "Oklahoma", "Arkansas"],
    }
};

export default mlbTeams;
